import styled from '@emotion/styled';

export const AlbumsNext = styled.div`
  max-width: 1500px;
  margin: auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  padding: 10px;
`;
